import React from 'react';

import PropTypes from 'prop-types';

import { PlaySolidIcon, Rotate360DegreeIcon } from '@iris/react-icons';

import { Button } from 'reaxl';

function MediaOverlayButton({
    type = 'spin',
    onClick = () => {},
    ariaLabel,
}) {
    const getIcon = () => {
        switch (type) {
            case 'video':
                return (
                    <PlaySolidIcon
                        className="media-overlay-icon"
                    />
                );
            case 'spin':
            default:
                return (
                    <Rotate360DegreeIcon
                        className="media-overlay-icon"
                    />
                );
        }
    };

    const getAriaLabel = () => {
        if (ariaLabel) return ariaLabel;
        switch (type) {
            case 'video':
                return 'Play video';
            case 'spin':
            default:
                return '360° Tour';
        }
    };

    return (
        <Button
            className={`media-overlay-button media-overlay-button-${type}`}
            bsStyle="text"
            onClick={onClick}
            aria-label={getAriaLabel()}
        >
            {getIcon()}
        </Button>
    );
}

MediaOverlayButton.propTypes = {
    type: PropTypes.oneOf(['spin', 'video']),
    onClick: PropTypes.func,
    ariaLabel: PropTypes.string,
};

export default MediaOverlayButton;
